import { render, staticRenderFns } from "./UploadDocs.vue?vue&type=template&id=a882b692&lang=true"
import script from "./UploadDocs.vue?vue&type=script&lang=js"
export * from "./UploadDocs.vue?vue&type=script&lang=js"
import style0 from "./UploadDocs.vue?vue&type=style&index=0&id=a882b692&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports